enum OrderConditionCustomFieldType {
  DATE = 'DATE',
  UNSIGNED_INTEGER = 'UNSIGNED_INTEGER',
  BOOLEAN = 'BOOLEAN',
  GENERIC_VALUES = 'GENERIC_VALUES',
}

export default OrderConditionCustomFieldType;
